import { msg } from 'gt-react';
import { ScissorsIcon } from '@phosphor-icons/react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../route';

const MillableReviewPage = lazyRouteComponent(
  () => import('./MillableReviewPage'),
  'MillableReviewPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/millable-review',
  staticData: {
    app: {
      nav: {
        label: msg('Unit-Level Review', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <ScissorsIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 38,
        groupOrder: 30,
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Inventory }],
      },
    },
  },
  component: MillableReviewPage,
  loader: () => ({
    crumb: msg('Unit-Level Review', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PROCUREMENT],
    });
  },
});
